import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../store/AuthContext';
import { GlobalSearchProvider } from '../../contexts/GlobalSearchContext';
import { GlobalCommandPalette } from '../global/GlobalCommandPalette';
import { useTrackRecentPages } from '../../hooks/useTrackRecentPages';

const LayoutContent: React.FC = () => {
  useTrackRecentPages();
  const headerRef = useRef<HTMLDivElement | null>(null);
  const sidebarRef = useRef<HTMLDivElement | null>(null);
  const { dimensions, setDimensions } = useAuth();

  const handleLogout = () => {
    console.log('Logout clicked');
  };

  useEffect(() => {
    const headerObserver = new ResizeObserver(() => {
      if (headerRef.current) {
        setDimensions((prev) => ({
          ...prev,
          header: {
            width: headerRef.current!.offsetWidth,
            height: headerRef.current!.offsetHeight,
          },
        }));
      }
    });

    const sidebarObserver = new ResizeObserver(() => {
      if (sidebarRef.current) {
        setDimensions((prev) => ({
          ...prev,
          sidebar: {
            width: sidebarRef.current!.offsetWidth,
            height: sidebarRef.current!.offsetHeight,
          },
        }));
      }
    });

    if (headerRef.current) headerObserver.observe(headerRef.current);
    if (sidebarRef.current) sidebarObserver.observe(sidebarRef.current);

    return () => {
      if (headerRef.current) headerObserver.unobserve(headerRef.current);
      if (sidebarRef.current) sidebarObserver.unobserve(sidebarRef.current);
    };
  }, [setDimensions]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <GlobalCommandPalette />
      <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>
        <div ref={sidebarRef} style={{ zIndex: 1 }}>
          <Sidebar onLogout={handleLogout} />
        </div>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            maxHeight: '100vh',
            height: '100vh',
            marginBottom: '2px',
            scrollbarWidth: 'none',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

const Layout: React.FC = () => (
  <GlobalSearchProvider>
    <LayoutContent />
  </GlobalSearchProvider>
);

export default Layout;
